import { createReduxActionTypes } from '../../../utils/actionFactory';

const SET_GROUPS = 'SET_GROUPS';
const RESET_GROUPS = 'RESET_GROUPS';
const SET_COLUMNS = 'SET_COLUMNS';
const UPDATE_IS_USERS_VIEW = 'UPDATE_IS_USERS_VIEW';
const RESET = 'RESET';

export const actionTypes = createReduxActionTypes('GROUPS', [
  SET_GROUPS,
  RESET_GROUPS,
  SET_COLUMNS,
  UPDATE_IS_USERS_VIEW,
  RESET
]);

const DEFAULT_STATE = {
  groups: [],
  groupsGroupedByUsers: [],
  columns: [],
  reset: true,
  isUsersView: false
};

export const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes[SET_GROUPS]: {
      return {
        ...state,
        groups: [...action.groups],
        groupsGroupedByUsers: [...action.groupsGroupedByUsers]
      };
    }
    case actionTypes[SET_COLUMNS]: {
      return { ...state, columns: [...action.columns] };
    }
    case actionTypes[RESET]: {
      return { ...state, reset: !state.reset };
    }
    case actionTypes[UPDATE_IS_USERS_VIEW]: {
      return { ...state, isUsersView: action.isUsersView };
    }
    case actionTypes[RESET_GROUPS]: {
      return { ...DEFAULT_STATE };
    }
    default:
      return state;
  }
};

export const actions = {
  setGroups: (groups, groupsGroupedByUsers) => ({
    type: actionTypes[SET_GROUPS],
    groups,
    groupsGroupedByUsers
  }),
  setColumns: columns => ({
    type: actionTypes[SET_COLUMNS],
    columns
  }),
  resetGroupUsers: () => ({
    type: actionTypes[RESET]
  }),
  updateIsUsersView: isUsersView => ({
    type: actionTypes[UPDATE_IS_USERS_VIEW],
    isUsersView
  }),
  resetGroups: () => ({ type: actionTypes[RESET_GROUPS] })
};
